<template>
  <Modal v-model="printPreviewWaybillModal" width="650" :title="printPreviewWaybillTitle" :transfer="false"
    :mask-closable="false" class-name="printPreviewWaybillStyle" @on-visible-change="printPreviewWaybillChange">
    <div class="flex align-items-center mb24">
      <span>{{ $t('key1000621') }}</span>
      <RadioGroup v-model="waybillSize">
        <Radio class="mr40" v-for="item in waybillSizeList" :label="item.value">{{ item.name }}</Radio>
      </RadioGroup>
    </div>
    <div class="flex align-items-start mb24" v-if="details">
      <span>{{ $t('key1000622') }}</span>
      <div class="stylePreview_box" :class="waybillSize === 2 ? 'stylePreview_70_20' : 'stylePreview_60_30'">
        <!--70*20 尺寸-->
        <template v-if="waybillSize === 2">
          <div class="flex align-items-center justify-content-between mb2">
            <span class="color-333 font-weight-bold">YMSSKU0000000005</span>
            <p class="flex align-items-center">
              <span class="color-333 font-weight-bold">120201-Black</span>
              <span class="color-333 font-weight-bold ml20">000815</span>
            </p>
          </div>
          <p :class="barcodeClass" v-html="details.skuBarcode"></p>
          <div class="flex align-items-center justify-content-between position-relative" style="top: -10px;">
            <span class="color-333 font-weight-bold">{{ $t('key1000623') }}</span>
            <span class="color-333 font-weight-bold">Made in China</span>
          </div>
        </template>
        <!--60*30 尺寸-->
        <template v-else>
          <p class="color-333 font-weight-bold font-size-15">YMSSKU0000000005</p>
          <p :class="barcodeClass" v-html="details.skuBarcode"></p>
          <div class="position-relative" style="top:-22px;">
            <div class="flex align-items-center justify-content-between">
              <span class="color-333 font-weight-bold">120201-Black</span>
              <span class="color-333 font-weight-bold">000815</span>
            </div>
            <div class="flex align-items-center justify-content-between">
              <span class="color-333 font-weight-bold">{{ $t('key1000623') }}</span>
              <span class="color-333 font-weight-bold">Made in China</span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="flex align-items-center mb24" v-if="!batchPrinting">
      <span class="red-dot">{{ $t('key1000624') }}</span>
      <InputNumber class="width_130" v-if="editablePrint" :max="maxPrintQuantity" :min="1"
        :formatter="value => `${parseInt(value)}`" v-model="printQuantity"></InputNumber>
      <span v-else>{{ printQuantity }}</span>
    </div>
    <template #footer>
      <Button @click="printPreviewWaybillModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" :disabled="printQuantity < 1" @click="printPreviewWaybillBtn">{{ $t('key1000320') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getProductBarCode, setConfigCharacters} from "@/utils/common";

export default {
  name: 'printPreviewWaybillModal',
  mixins: [Mixin],
  props: {
    printUrl: {
      type: String,
      default: null
    },
    // 是否是批量打印
    batchPrinting: {
      type: Boolean,
      default: false
    },
    // 最大打印数量
    maxPrintQuantity: {
      type: Number,
      default: 9999999
    },
    // 是否可编辑打印数量
    editablePrint: {
      type: Boolean,
      default: true
    },
    // 打印类型
    printType: {
      type: String,
      default: null,
    },
    printPreviewWaybillTitle: {
      type: String,
      default: `${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000320')}${setConfigCharacters()}${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000616')}`
    }
  },
  data() {
    let v = this;
    return {
      printPreviewWaybillModal: false,
      waybillSize: 2,
      printQuantity: 1,
      waybillSizeList: [
        {value: 2, name: '70mm * 20mm'},
        {value: 1, name: '60mm * 30mm'},
      ],
      details: null,
      printList: [],
    };
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    },
    barcodeClass() {
      return this.waybillSize === 2 ? 'barcode-70-20' : 'barcode-60-30';
    }
  },
  methods: {
    // 初始化数据
    initPrintPreviewWaybillData(obj, printList) {
      getProductBarCode({type: this.waybillSize, sku: obj.ymsSku || obj.sku}).then((data) => {
        obj.skuBarcode = data || '';
        this.printQuantity = obj.quantity || 1;
        this.details = obj;
        if (this.batchPrinting) {
          this.printList = printList;
        }
        this.printPreviewWaybillModal = true;
      });
    },
    // 打印
    printPreviewWaybillBtn() {
      const handleData = (obj) => {
        this.axios.post(this.printUrl, JSON.stringify(obj),
          {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let id = this.details.ymsSku || this.details.ymsProductGoodsId || this.details.productGoodsId;
              this.commonPrint(data, id).then(() => {
                this.printPreviewWaybillModal = false;
                this.$emit('updatePrint', true);
              });
            } else {
              this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000617'));
              return false;
            }
          } else if (response.data.code === 220026) {
            this.$Modal.warning({
              title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000618'),
              content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000619'),
              okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000316')
            });
          }
        });
      };
      if (this.batchPrinting) {
        let obj = null;
        switch (this.printType) {
          // 供应商系统--备货单列表、集货订单列表、直发订单列表--批量打印条码
          case 'supplier_batchPrintingBarcodes':
            obj = {
              printPackageOrderGoodsBos: this.printList.map(i => ({
                packageId: i.packageId
              })),
              type: this.waybillSize
            };
            break;
          // 供应商系统--商品管理--查看sku详情--打印条码
          case 'supplier_viewSku':
            obj = this.printList.map(i => ({
              productGoodsId: i.productGoodsId,
              quantity: 1,
              type: 0,
              printType: this.waybillSize
            }));
            break;
          default:
            obj = {
              appendYmsExpressBillBos: this.printList.map(i => ({
                quantity: i.printQuantity,
                ymsProductGoodsId: i.ymsProductGoodsId
              })),
              type: this.waybillSize
            };
            break;
        }
        handleData(obj);
      } else {
        if (this.printQuantity <= 0) {
          this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000620'));
          return false;
        }
        let obj;
        if (this.system === 'yms') {
          obj = {
            appendYmsExpressBillBos: [
              {
                quantity: this.printQuantity,
                ymsProductGoodsId: this.details.ymsProductGoodsId
              }
            ],
            type: this.waybillSize
          };
        }
        if (this.system === 'supplier') {
          obj = [{
            productGoodsId: this.details.productGoodsId,
            quantity: this.printQuantity,
            type: 0,
            printType: this.waybillSize
          }];
        }
        handleData(obj);
      }
    },
    // 自动打印面单
    automaticallyPrintWaybill(quantity, ymsProductGoodsId) {
      this.printQuantity = quantity;
      this.details = {
        ymsProductGoodsId: ymsProductGoodsId
      };
      this.printPreviewWaybillBtn();
    },
    // 监听弹窗
    printPreviewWaybillChange(value) {
      if (!value) {
        this.details = null;
        this.waybillSize = 2;
        this.printQuantity = 1;
        this.printList = [];
      }
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="less" scoped>
/deep/ .printPreviewWaybillStyle {
  .stylePreview_box {
    border: 1px solid #F1F1F1;
    padding: 8px 10px;

    // 70 × 20
    .barcode-70-20 {
      width: 100%;

      img {
        width: 410px !important;
        height: 70px !important;
        position: relative;
        left: -10px;
      }
    }

    // 60 × 30
    .barcode-60-30 {
      width: 100%;

      img {
        width: 351px !important;
        height: 115px !important;
        position: relative;
        left: -10px;
        top: -2px;
      }
    }
  }

  .stylePreview_70_20 {
    width: 413px;
    height: 118px;
    font-size: 12px;
  }

  .stylePreview_60_30 {
    width: 354px;
    height: 177px;
  }
}
</style>
